import { moveEvent, SourceDateLockedError, type DisplayItem, type MoveTarget } from '@autoday/core';
import { getStore } from '../store/appStore.ts';
import { errorText, toast } from '../ui/toast.tsx';
import { randomId } from '../platform.ts';
import { tr } from '../i18n/i18n.ts';
import { formatClock, formatDateLong, localizeError } from '../i18n/format.ts';

/** Gemensam väg för drag-and-drop och "Flytta till datum": domänoperation → sparad → toast med Ångra. */
export async function runMove(item: DisplayItem, target: MoveTarget, scope: 'series' | 'occurrence') {
  const store = getStore();
  const ref = item.ref.kind === 'local' ? item.ref.id : item.ref.key;
  try {
    const res = await store.run((s) => moveEvent(s, randomId('mv_'), ref, target, store.clock.now(), { scope, occurrenceKey: item.occurrenceKey }));
    const ev = res.state.events[ref];
    const when = ev ? (ev.timing.kind === 'allDay' ? formatDateLong(ev.timing.start, false) : formatDateLong(ev.timing.start.slice(0, 10), false) + ' ' + formatClock(Number(ev.timing.start.slice(11, 13)), Number(ev.timing.start.slice(14, 16)))) : '';
    const one = scope === 'occurrence' && item.recurring;
    toast({
      kind: res.adjusted ? 'warn' : 'ok',
      text: tr(
        `"${item.title}" flyttad${one ? ' (en förekomst)' : ''} till ${when}.${res.adjusted ? ' Tiden fanns inte p.g.a. sommartid och justerades.' : ''}`,
        `"${item.title}" moved${one ? ' (one occurrence)' : ''} to ${when}.${res.adjusted ? ' The time did not exist because of daylight saving and was adjusted.' : ''}`,
      ),
      action: res.undo
        ? { label: tr('Ångra', 'Undo'), run: () => void store.undo(res.undo!.opId).then((l) => toast({ kind: 'info', text: `${tr('Ångrat', 'Undone')}: ${localizeError(l)}` })).catch((e) => toast({ kind: 'error', text: errorText(e) })) }
        : undefined,
    });
  } catch (e) {
    toast({ kind: 'error', text: e instanceof SourceDateLockedError ? errorText(e) : `${tr('Flytten genomfördes inte.', 'The move was not made.')} ${errorText(e)}` });
  }
}
